module.exports = __webpack_public_path__ + "static/media/PT.0d3ea2fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PT.svg
// module id = 343
// module chunks = 0